/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordBody
 */
export interface ChangePasswordBody {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBody
     */
    oldPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBody
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordBody
     */
    confirmPassword: string;
}

/**
 * Check if a given object implements the ChangePasswordBody interface.
 */
export function instanceOfChangePasswordBody(value: object): value is ChangePasswordBody {
    if (!('oldPassword' in value) || value['oldPassword'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    if (!('confirmPassword' in value) || value['confirmPassword'] === undefined) return false;
    return true;
}

export function ChangePasswordBodyFromJSON(json: any): ChangePasswordBody {
    return ChangePasswordBodyFromJSONTyped(json, false);
}

export function ChangePasswordBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordBody {
    if (json == null) {
        return json;
    }
    return {
        
        'oldPassword': json['oldPassword'],
        'newPassword': json['newPassword'],
        'confirmPassword': json['confirmPassword'],
    };
}

export function ChangePasswordBodyToJSON(json: any): ChangePasswordBody {
    return ChangePasswordBodyToJSONTyped(json, false);
}

export function ChangePasswordBodyToJSONTyped(value?: ChangePasswordBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oldPassword': value['oldPassword'],
        'newPassword': value['newPassword'],
        'confirmPassword': value['confirmPassword'],
    };
}

